import { Avatar, Mentions } from 'antd'
import { MentionProps as AntdMentionProps } from 'antd/lib/mentions'
import cls from 'classnames'
import React from 'react'

import { useSearchUserLazyQuery } from '@/generated/graphql'

import s from './mention.module.less'

interface MentionProps {
  value: string
  onValueChange: (value: string) => void
  border?: boolean
}

export const Mention = React.forwardRef(
  ({ value, onValueChange, border = true, ...props }: MentionProps & AntdMentionProps, ref: any) => {
    const [search, { data, loading }] = useSearchUserLazyQuery({
      fetchPolicy: 'no-cache',
    })

    const users = (data ? data.users.edges.map(({ node }) => node) : []).map((u) => (
      <Mentions.Option key={String(u.userId)} value={u.email.split('@')[0]}>
        <div>
          <Avatar src={u.avatarUrl} style={{ marginRight: 8 }} />
          <span>{u.name}</span>
        </div>
      </Mentions.Option>
    ))

    return (
      <Mentions
        ref={(c: any) => {
          if (ref) {
            ref.current = c && c.textarea
          }
        }}
        {...props}
        className={cls(props.className, s.container, {
          [s.noBorder]: !border,
        })}
        value={value}
        onChange={onValueChange}
        onSearch={(text) =>
          search({
            variables: {
              filter: {
                search: text,
              },
              pagination: {
                first: 10,
              },
            },
          })
        }
        loading={loading}
      >
        {users}
      </Mentions>
    )
  }
)
